module.exports = __webpack_public_path__ + "img/148.fad6dd41.jpg";